import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { CardBody, Container, Modal, ModalBody } from 'reactstrap';
import { Card } from 'reactstrap';
import TextField from '@mui/material/TextField';
import { Autocomplete } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useNavigate,useLocation } from 'react-router-dom';
import { child_employees, products } from '../../api/requisition';
import { toast } from 'react-toastify';
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { productCategoryObj } from '../helper';
import { useDispatch, useSelector } from "react-redux";
import { StoreSalesHeadRequisition } from '../../store/salesHead/action';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import handImg from '../../assets/images/front_hand.svg';
import { StorePageHeaderName } from '../../store/pageHeader/action';
import AddIcon from '@mui/icons-material/Add';
import useTitle from '../../helpers/helper';



const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input': {
    fontSize: '10px',
  },
  '& .MuiInputBase-input:focus': {
    fontSize: '10px',
  },
}));
const NewSalesHeadCreateRequisition = () => {
  useTitle("Procurement-requisition");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const requisitionData = useSelector((state) => state.salesHead);
  const [productCategory, setProductCategory] = useState(productCategoryObj[0]);
  const [rows, setRows] = useState([
    {
        productName: '',
        productObj: null,
        executiveObj: null,
        quantity: '',
        value: 0,
        mop:0,
        productOptions: [], // Initial empty
        executiveOptions: [], // Initial empty

        subRows: [], // Initialize with an empty array of sub-rows
        errors: {
            executiveNameError: '',
            productNameError: '',
            quantityError: '',
            valueError: ''
        }
    }
]);
const [executiveOptions, setExecutiveOptions] = useState([]);
const [productCategoryError, setProductCategoryError] = useState('');
const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
const [selectedRowIndex, setSelectedRowIndex] = useState(null);
const [prevRoute, setPrevRoute] = useState('');


useEffect(() => {
  const handlePageLoad = () => {
    const navigationEntries = performance.getEntriesByType('navigation');
    if (navigationEntries.length > 0) {
      const navigationType = navigationEntries[0].type;
      if (navigationType === 'reload') {
        // If the page is refreshed, reset the location state
        navigate(location.pathname, { replace: true, state: { ...location.state, prevRoute: '' } });
      }
    } else {
      setPrevRoute(location.state?.prevRoute || '');
    }
  };

  handlePageLoad();
}, [location, navigate]);


useEffect(() => {
  if (location.state && location.state.prevRoute === '/sales-head/add-requisition' && requisitionData.requisitionData.length > 0) {
      setRows(requisitionData.requisitionData);
      setProductCategory(requisitionData.productCategory)
  }
}, [location.state, requisitionData]);


useEffect(() => {
    console.log('mounted')
    dispatch(StorePageHeaderName('Create Requisition'));
    if(!location.state || (location.state && location.state.prevRoute !== '/sales-head/add-requisition')){

      fetchExecutiveList(0, rows)
      fetchProductList(productCategory,0, rows)
    }



  }, []);

  const openModal = (index) => {
    setSelectedRowIndex(index);
    setIsDeleteModalOpen(true);
  };

  const closeModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedRowIndex(null);
  };

  const goToRequisition = () => {

    let hasInvalidData = false;

    if (!productCategory) {
      setProductCategoryError('Type is required');
      hasInvalidData = true;
    } else {
      setProductCategoryError('');
    }
    const updatedRows = rows.map(row => {
      const updatedRow = { ...row };
      console.log('go to req..', row)

      if (!row.executiveObj) {
        updatedRow.errors.executiveNameError = 'Executive Name is required';
        hasInvalidData = true;
      }
      if (!row.productObj) {
        updatedRow.errors.productNameError = 'Product Name is required';
        hasInvalidData = true;
      } else if (!row.mop) {
        updatedRow.errors.productNameError = 'Product\'s MOP is empty';
        hasInvalidData = true;
      }

      

      if (!row.quantity || row.quantity == 0) {
        console.log(row.quantity )
        updatedRow.errors.quantityError = 'Quantity is required';
        hasInvalidData = true;
      }
      if (row.quantity &&  row.quantity >9999) {
        console.log(row.quantity )
        updatedRow.errors.quantityError = 'Quantity should be 1-9999';
        hasInvalidData = true;
      }
      if (!row.value  || row.value == 0) {
        console.log('hiiiiiiiii',row.value)
        updatedRow.errors.valueError = 'Value is required';
        hasInvalidData = true;
      }
  
      // Check for invalid data in sub-rows
      updatedRow.subRows = row.subRows.map(subRow => {
        const updatedSubRow = { ...subRow };
  
        if (!subRow.productObj) {
          updatedSubRow.productNameError = 'Product Name is required';
          hasInvalidData = true;
        } else if (!subRow.mop) {
          updatedSubRow.productNameError = 'Product\'s MOP is empty';
          hasInvalidData = true; 
      }
        
        if (!subRow.quantity || subRow.quantity === '0') {
          updatedSubRow.quantityError = 'Quantity is required';
          hasInvalidData = true;
        }
        if (subRow.quantity && subRow.quantity > 9999) {
          updatedSubRow.quantityError = 'Quantity should be 1-9999';
          hasInvalidData = true;
        }
        if (!subRow.value || subRow.value === '0') {
          updatedSubRow.valueError = 'Value is required';
          hasInvalidData = true;
        }
        
        return updatedSubRow;
      });
  
      return updatedRow;
    });
  
    setRows(updatedRows);
  
    if (hasInvalidData || !productCategory) {
      return;
    }
    const resultPayload = {
      storedRows: updatedRows,
      productCategory
  }
    dispatch(StoreSalesHeadRequisition(resultPayload))

    navigate("/sales-head/add-requisition", { state: { rows } });
  };



  const fetchExecutiveList = async (mainRowIndex, updatedrows, newInputValue) =>{
    console.log('newInputValue',newInputValue)
      const updatedRows = updatedrows
    try {
       
         const  response = await child_employees();

           if (response.statusCode === 200 && response.data.allChilds.length > 0) {
             const transformedData = response.data.allChilds.map(child => {
               const { id, first_name, last_name } = child.userDetail;
               return { label: `${first_name} ${last_name}`, value: id };
             });
               
            
                    updatedRows[mainRowIndex].executiveOptions= transformedData;
                    
           
                     const selectedExecutiveValues = new Set();
                     updatedRows.forEach((row, idx) => {
                         if (idx !== mainRowIndex && row.executiveObj) {
                             if( row.executiveObj){
                               selectedExecutiveValues.add(row.executiveObj.value);
                             }
           
                         }
                     });
                     
                     updatedRows[mainRowIndex].executiveOptions = updatedRows[mainRowIndex].executiveOptions.filter(option =>
                         !selectedExecutiveValues.has(option.value)
                     );
                    if(newInputValue && newInputValue !== ''){
                        updatedRows[mainRowIndex].executiveOptions = updatedRows[mainRowIndex].executiveOptions.filter(option =>
                            option.label.toLowerCase().includes(newInputValue.toLowerCase())
                          );
                    }    
           }
       
    }
    catch(error){
        console.log(error)
        toast.error('Error in fetching executive list for sales head')
    }

    finally {
        setRows([...updatedRows]); 
    }
  }

  const fetchProductList = async (productCategoryObj, mainRowIndex, updatedrows, newMainInputValue, isSubrow = false, subrowIndex, newSubRowInputValue) =>{
      const updatedRows = updatedrows
      console.log(" productCategory", productCategory)
    try {
        let product_list = []
        if((newMainInputValue && newMainInputValue !== '') || (newSubRowInputValue && newSubRowInputValue !== '')){

            let search = '';
            if(newMainInputValue && newMainInputValue !== ''){
                search = newMainInputValue;
            }
            else if(newSubRowInputValue && newSubRowInputValue !== ''){
                search = newSubRowInputValue;
            }
             product_list = await products({ search_type: productCategoryObj.value, search_item: search});
        }
        else{

             product_list = await products({ search_type: productCategoryObj.value});
        }

        if(product_list.statusCode === 200 && product_list.data.productList[0].length > 0){
            if (isSubrow && subrowIndex !== undefined) {
                const mainRowProductObj = updatedRows[mainRowIndex].productObj;

                const otherSubRowProducts = updatedRows[mainRowIndex].subRows
                  .filter((_, idx) => idx !== subrowIndex) // Filter out the current sub-row
                  .map(subRow => subRow.productObj?.value); // Get product values from other sub-rows

                console.log('otherSubRowProducts--',otherSubRowProducts,'mainRowProductObj',mainRowProductObj)

                

                updatedRows[mainRowIndex].subRows[subrowIndex].productOptions = product_list.data.productList[0]
                  .filter(product => {
                    // Filter out main row product and other sub-row products
                    return product.ItemNo !== mainRowProductObj?.value && !otherSubRowProducts.includes(product.ItemNo);
                  })
                  .map(product => ({
                    label: product.ItemName,
                    value: product.ItemNo,
                    productName: product.ItemName,
                    Mop: product.Mop,
                    Dp: product.Dp,
                    Ptype: product.Ptype,
                    Vertical: product.Vertical,
                    Itemseg: product.Itemseg,
                    Category: product.Category,
                    vcode: product.Vcode,
                    vname: product.Vname,
                    vtype: product.Vtype
                  }));
              } 
              else {

                  updatedRows[mainRowIndex].productOptions = product_list.data.productList[0].map(product => ({
                      label: product.ItemName,
                      value: product.ItemNo,
                      productName: product.ItemName,
                      Mop: product.Mop,
                      Dp: product.Dp,
                      Ptype:product.Ptype,
                      Vertical: product.Vertical,
                      Itemseg: product.Itemseg,
                      Category: product.Category,
                      vcode: product.Vcode,
                      vname: product.Vname,
                      vtype: product.Vtype
                  }));

                  const hasSubRows = updatedRows[mainRowIndex].subRows.length > 0;
                  if (hasSubRows) {
                    const otherSubRowProducts = updatedRows[mainRowIndex].subRows
                    .map(subRow => subRow.productObj?.value);

                    updatedRows[mainRowIndex].productOptions = updatedRows[mainRowIndex].productOptions
                    .filter(product => {
                      return !otherSubRowProducts.includes(product.value);
                    });
                  }
              }


        }
        else {
          if (isSubrow && subrowIndex !== undefined) {
            updatedRows[mainRowIndex].subRows[subrowIndex].productOptions = []
          }
          else {

            updatedRows[mainRowIndex].productOptions =  []
          }

        }
    }
    catch(error){
        console.log(error)
        toast.error('Error in fetch product list for sales head')
    }
    finally{
        setRows([...updatedRows]); 

    }

  }

  

  const handleAddSubRow = async (mainRowIndex) => {
    const updatedRows = [...rows];

    const mainRow = updatedRows[mainRowIndex];

    // Perform main row validation
    let hasErrors = false;
    if (!mainRow.executiveObj) {
      mainRow.errors.executiveNameError = 'Executive Name is required';
      hasErrors = true;
    } else {
      mainRow.errors.executiveNameError = '';
    }
  
    if (!mainRow.productObj) {
      mainRow.errors.productNameError = 'Product Name is required';
      hasErrors = true;
    } else if (!mainRow.mop) {
      mainRow.errors.productNameError = 'Product\'s MOP is empty';
      hasErrors = true;
    } else {
      mainRow.errors.productNameError = '';
    }

    
  
    if (!mainRow.quantity ||  mainRow.quantity == '0') {
      mainRow.errors.quantityError = 'Quantity is required';
      hasErrors = true;
    }
    else if(mainRow.quantity > 9999){
      mainRow.errors.quantityError = 'Quantity should be 1-9999';
      hasErrors = true;
    }
     else {
      mainRow.errors.quantityError = '';
    }
  
    if (mainRow.value <= 0) {
      mainRow.errors.valueError = 'Value is required';
      hasErrors = true;
    } else {
      mainRow.errors.valueError = '';
    }
  
    // Check other sub-rows for validation
    mainRow.subRows.forEach((subRow, subRowIndex) => {
      if (!subRow.productObj) {
        subRow.productNameError = 'Product Name is required';
        hasErrors = true;
      } else if (!subRow.mop) {
        subRow.productNameError = 'Product\'s MOP is empty';
        hasErrors = true;
      } else {
        subRow.productNameError = '';
      }

      
  
      if (!subRow.quantity || subRow.quantity == '0') {
        subRow.quantityError = 'Quantity is required';
        hasErrors = true;
      } 
      else if(subRow.quantity > 9999){
        subRow.quantityError = 'Quantity should be 1-9999';
        hasErrors = true;
      }
      else {
        subRow.quantityError = '';
      }
  
      if (subRow.value <= 0) {
        subRow.valueError = 'Value is required';
        hasErrors = true;
      } else {
        subRow.valueError = '';
      }
    });
  
    if (hasErrors) {
      // Update state with the error messages and exit
      setRows([...updatedRows]);
      return;
    }

    const subRowIndex = updatedRows[mainRowIndex].subRows.length; // Calculate the subRowIndex dynamically
    updatedRows[mainRowIndex].subRows.push({
      productOptions: [],
      quantity: '',
      value: '',
      mop:0,
      productObj: null,
    });
    await fetchProductList(productCategory,mainRowIndex, updatedRows, '', true, subRowIndex);
    setRows(updatedRows);
  };

  // Function to handle sub-row input changes
  const handleSubRowChange = (mainRowIndex, subRowIndex, field, value) => {
    const updatedRows = [...rows];
    updatedRows[mainRowIndex].subRows[subRowIndex][field] = value;
    setRows(updatedRows);
  };



  const handleAddRow = async() => {
    const newRow = {
        productName: '',
        productObj: null,
        executiveObj: null,
        quantity: '',
        mop:0,
        value: 0,
        productOptions: [],
        executiveOptions: [], // Initial empty

        
        subRows: [],
        errors: {
          productNameError: '',
          quantityError: '',
          valueError: ''
        }
      }
      const updatedRows = [...rows, newRow];
      const newIndex = updatedRows.length - 1;
      await fetchExecutiveList(newIndex, updatedRows);
      await fetchProductList(productCategory,newIndex, updatedRows)

  };

  const handleProductCategoryChange = (event, newValue) => {
    console.log("product category function called")
    setProductCategory(newValue);

    

  const updatedRows = rows.map((row, mainRowIndex) => {
    if (!row.productObj) {
      console.log("null product obj---",row)
      fetchProductList(newValue,mainRowIndex, rows, '', false, undefined, '');
    }

    const updatedSubRows = row.subRows.map((subRow, subRowIndex) => {
      if (!subRow.productObj) {
        fetchProductList(newValue,mainRowIndex, rows, '', true, subRowIndex, '');
      }
      return subRow;
    });

    return {
      ...row,
      subRows: updatedSubRows,
    };
  });

  // setRows(updatedRows);

    
    
  };
    const handleMainRowExecutiveChange = (mainRowindex, value) => {
        console.log('handleMainRowExecutiveChange--', mainRowindex, value)
        const updatedRows = [...rows];
        updatedRows[mainRowindex].executiveObj = value;
        updatedRows[mainRowindex].errors.executiveNameError=''

        setRows(updatedRows);
    };

   const handleMainRowExecutiveInputChange = async (mainRowindex, newInputValue) =>{
    console.log('newInputValue',newInputValue)
        const updatedRows = [...rows];
        await fetchExecutiveList(mainRowindex, updatedRows, newInputValue);

   }

   const handleMainRowProductChange = (mainRowindex, value) => {
        console.log('handleMainRowProductChange--', mainRowindex, value)
        const updatedRows = [...rows];
        updatedRows[mainRowindex].productObj = value;
        updatedRows[mainRowindex].quantity = 0;
        updatedRows[mainRowindex].value=0
        updatedRows[mainRowindex].mop=value ? value.Mop : 0
        updatedRows[mainRowindex].errors.productNameError=''
        setRows(updatedRows);
    };
    const handleMainRowProductInputChange = async (index, newInputValue) => {
      console.log('handleMainRowProductInputChange')
        const updatedRows = [...rows];
        await fetchProductList(productCategory,index, updatedRows,  newInputValue);
    };

    const handleSubRowProductChange = (mainRowindex,subRowIndex, value) => {
        console.log('handleSubRowProductChange--', mainRowindex, subRowIndex, value)
        const updatedRows = [...rows];
        updatedRows[mainRowindex].subRows[subRowIndex].productObj = value;
        updatedRows[mainRowindex].subRows[subRowIndex].quantity = 0;
        updatedRows[mainRowindex].subRows[subRowIndex].value=0
        updatedRows[mainRowindex].subRows[subRowIndex].mop=value ? value.Mop : 0
        updatedRows[mainRowindex].subRows[subRowIndex].productNameError=''

        setRows(updatedRows);
    };

    const handleSubRowProductInputChange = async(mainRowindex,subRowIndex, value) =>{
        const updatedRows = [...rows];

        await fetchProductList(productCategory, mainRowindex, updatedRows,'', true, subRowIndex,value);
    }

    const handleMainRowDelete = (mainRowIndex) => {
      const updatedRows = [...rows];
      updatedRows.splice(mainRowIndex, 1); // Remove main row at index mainRowIndex
      setRows(updatedRows);
      closeModal()

    };
  
    const handleSubRowDelete = (mainRowIndex, subRowIndex) => {
      const updatedRows = [...rows];
      updatedRows[mainRowIndex].subRows.splice(subRowIndex, 1); // Remove sub row at index subRowIndex
      setRows(updatedRows);
    };
    
    const handleQuantityChange = (mainRowIndex, newValue) => {
      newValue = parseInt(newValue, 10);

      if (isNaN(newValue) || newValue <= 0) {
          newValue = 0;
      }
      
   
      const updatedRows = [...rows];
      updatedRows[mainRowIndex].quantity = newValue;

      let dpVal = 0
      if( updatedRows[mainRowIndex].productObj.Dp){
        dpVal = updatedRows[mainRowIndex].productObj.Dp
      }
   
      updatedRows[mainRowIndex].value = newValue *  dpVal
    
      if(  updatedRows[mainRowIndex].value > 0){
          updatedRows[mainRowIndex].errors.valueError = '';

      }
      if(newValue > 0 && newValue <= 9999){
          updatedRows[mainRowIndex].errors.quantityError = '';

      }
      if(newValue > 9999){
        updatedRows[mainRowIndex].errors.quantityError = 'Quantity should be 1-9999';

    }


      setRows(updatedRows);
    };

    const handleValueChange = (mainRowIndex, newValue) => {
      const updatedRows = [...rows];
      updatedRows[mainRowIndex].value = newValue;
      setRows(updatedRows);
  };

  const handleSubrowQuantityChange = (mainRowIndex, subrowIndex, newValue) => {
    newValue = parseInt(newValue, 10);

    if (isNaN(newValue) || newValue <= 0) {
        newValue = 0;
    }
    
 
    const updatedRows = [...rows];
    updatedRows[mainRowIndex].subRows[subrowIndex].quantity = newValue;

    let dpVal = 0

    if( updatedRows[mainRowIndex].subRows[subrowIndex].productObj.Dp){
      dpVal = updatedRows[mainRowIndex].subRows[subrowIndex].productObj.Dp
    }
 
    updatedRows[mainRowIndex].subRows[subrowIndex].value = newValue *  dpVal
  
    if(  updatedRows[mainRowIndex].subRows[subrowIndex].value > 0){
        updatedRows[mainRowIndex].subRows[subrowIndex].valueError = '';

    }
    if(newValue > 0 && newValue <= 9999){
        updatedRows[mainRowIndex].subRows[subrowIndex].quantityError = '';

    }
    if(newValue > 9999){
      updatedRows[mainRowIndex].subRows[subrowIndex].quantityError = 'Quantity should be 1-9999';

    }

    setRows(updatedRows);
  };
  const handleSubrowValueChange = (mainRowIndex, subrowIndex, newValue) => {
    const updatedRows = [...rows];
    updatedRows[mainRowIndex].subRows[subrowIndex].value = newValue;
    setRows(updatedRows);
};
  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
        <div className='mb-3'>
          <h3 className="requisition_text mb-0">Requisition Form</h3>
          </div>
          <Card className='mb-3'>
            <CardBody>
                <div className='d-flex align-items-center mb-2'>
                    <div>
                        <p className='mb-0 me-2 requisition_type_text'>Requisition Type : </p>
                    </div>
                    <div>
                        <Autocomplete
                            className="create_requisition_field"
                            id={`product-category`}
                            sx={{ width: 150 }}
                            options={productCategoryObj}
                            value={productCategory}
                            onChange={handleProductCategoryChange}
                            clearIcon={null} // This will hide the cancel icon

                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Type"
                                />
                            )}
                        />
                        {!productCategory && productCategoryError && <span className="error-message" style={{ color: 'red', fontSize: '14px' }}>{productCategoryError}</span>}

                    </div>
                </div>
              {rows.map((row, mainRowIndex) => (
                <div
                  className='create_requisition'
                  key={mainRowIndex}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    marginTop: '15px',
                    padding: '15px',
                    backgroundColor: '#FAFDFF',
                    border: '1px solid #C3E8FF',
                    borderRadius: '5px',
                  }}
                >
                  {/* <Grid container spacing={1}> */}
                    {/* <Grid item xs={3}> */}
                  <div className='d-flex flex-row gap-2 flex-wrap'>
                    <div className='d-flex flex-row gap-2 flex-wrap'>
                    <div>
                      <Autocomplete
                        className="create_requisition_field"
                        id={`executive-list-${mainRowIndex}`}
                        sx={{
                          width: {
                            xs: '100%',
                            sm: '260px',
                            md: '290px',
                            lg: {
                              xs: '90%',
                              lg: '305px',
                            },
                            xl: '355px',
                          },
                          '@media (min-width: 1200px) and (max-width: 1360px)': {
                            width: 'calc(300px - 50px)',
                           },
                        }}
                        options={row.executiveOptions}
                        value={row.executiveObj}
                        onChange={(event, newValue) => handleMainRowExecutiveChange(mainRowIndex, newValue)}
                         onInputChange={(event, newInputValue) => handleMainRowExecutiveInputChange(mainRowIndex, newInputValue)} // Add this line
                         isOptionEqualToValue={(option, value) => option.value === value.value} // Customize the equality test

                         renderInput={(params) => (
                          <TextField {...params} label="Executive Name" />
                        )}
                      />
                      {row.errors.executiveNameError && <div className="error-message" style={{ color: 'red' }}>{row.errors.executiveNameError}</div>}
                    </div>
                    {/* </Grid>
                    <Grid item xs={3}> */}
                    <div>
                      <div>
                      <Autocomplete
                        className="create_requisition_field"
                        id={`product-list-${mainRowIndex}`}
                        sx={{
                          width: {
                            xs: '100%',
                            sm: '260px',
                            md: '290px',
                            lg: {
                              xs: '90%',
                              lg: '305px',
                            },
                            xl: '355px',
                          },
                          '@media (min-width: 1200px) and (max-width: 1360px)': {
                            width: 'calc(300px - 50px)',
                           },
                        }}
                        options={row.productOptions}
                        value={row.productObj}
                        onChange={(event, newValue) => handleMainRowProductChange(mainRowIndex, newValue)}
                        onInputChange={(event, newInputValue) => handleMainRowProductInputChange(mainRowIndex, newInputValue)} // Add this line
                        isOptionEqualToValue={(option, value) => option.value === value.value} // Customize the equality test

                        renderInput={(params) => (
                          <TextField {...params} label="Product Name" />
                        )}
                      />
                      {row.errors.productNameError && <div className="error-message" style={{ color: 'red' }}>{row.errors.productNameError}</div>}
                    </div>
                    { row.subRows.length=== 0 &&
                          <div className='mt-2'>
                        <button onClick={() => handleAddSubRow(mainRowIndex )} style={{ marginTop: '2px' }} className='add_more_button'>
                          <AddIcon /> Add Product
                        </button>
                      </div>
                        }
                        </div>
                    {/* </Grid>
                    <Grid item xs={2}> */}
                    <div>
                      <TextField
                        id={`quantity-${mainRowIndex}`}
                        label="Quantity"
                        variant="outlined"
                        className="create_requisition_textfield"
                        value={row.quantity}
                        onChange={(event) => handleQuantityChange(mainRowIndex,event.target.value)}
                        sx={{
                          width: {
                            xs: '100%',
                            sm: '190px',
                            md: '220px',
                            lg: {
                              xs: '90%',
                              lg: '220px',
                            },
                            xl: '260px',
                          },
                          '@media (min-width: 1200px) and (max-width: 1360px)': {
                            width: 'calc(250px - 50px)',
                           },
                        }}
                        disabled={!row.productObj}
                      />
                      {row.errors.quantityError && <div className="error-message" style={{ color: 'red' }}>{row.errors.quantityError}</div>}
                    </div>
                    {/* </Grid>
                    <Grid item xs={2}> */}
                    <div>
                      <TextField
                        id={`value-${mainRowIndex}`}
                        label="Value"
                        variant="outlined"
                        className="create_requisition_textfield"
                        value={row.value}
                        onChange={(event) => handleValueChange(mainRowIndex,  event.target.value)}
                        sx={{
                          width: {
                            xs: '100%',
                            sm: '190px',
                            md: '220px',
                            lg: {
                              xs: '90%',
                              lg: '220px',
                            },
                            xl: '260px',
                          },
                          '@media (min-width: 1200px) and (max-width: 1360px)': {
                            width: 'calc(250px - 50px)',
                           },
                        }}
                        disabled={true}
                      />
                      {row.errors.valueError && <div className="error-message" style={{ color: 'red' }}>{row.errors.valueError}</div>}
                    </div>
                    {/* </Grid> */}
                    {rows.length > 1 && (
                      <div className='d-flex align-items-center'>
                        <HighlightOffIcon
                          color='error'
                          // onClick={() => handleMainRowDelete(mainRowIndex)}
                          onClick={() => openModal(mainRowIndex)}
                          style={{ cursor: 'pointer', alignSelf: 'flex-start', marginTop: '10px' }}
                        />

                      </div>
                    )}
                    {/* <Grid item xs={2}> */}
                    {/* <div>
                      <button onClick={() => handleAddSubRow(mainRowIndex )} style={{ marginTop: '2px' }} className='add_more_button'>
                        <AddIcon /> Add Product
                      </button>
                      </div> */}
                    {/* </Grid>
                  </Grid> */}
                  </div>
                  {row.subRows.map((subRow, subRowIndex) => (
                    <div
                      key={subRowIndex}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        // gap: '10px',
                        // marginTop: '7px',
                        // paddingLeft: '10px',
                        // paddingRight: '10px',
                        paddingTop: '5px',
                        // backgroundColor: '#EAF1FF',
                        // border: '1px solid #BFD9FF',
                        // borderRadius: '5px',
                      }}
                    >
                      {/* <Grid container spacing={1}> */}
                        {/* <Grid item xs={4}> */}
                        <div className='d-flex flex-row gap-2 flex-wrap'>
                          <div className="responsive-div"></div>
                         <div>
                          <div>
                          <Autocomplete
                            className="create_requisition_field"
                            id={`subproduct-list-${mainRowIndex}-${subRowIndex}`}
                            sx={{
                              width: {
                                xs: '100%',
                                sm: '270px',
                                md: '290px',
                                lg: {
                                  xs: '90%',
                                  lg: '305px',
                                },
                                xl: '355px',
                              },
                              '@media (min-width: 1200px) and (max-width: 1360px)': {
                                width: 'calc(300px - 50px)',
                               },
                            }}
                            options={subRow.productOptions}
                            value={subRow.productObj}

                            onChange={(event, newValue) => handleSubRowProductChange(mainRowIndex, subRowIndex, newValue)}
                            onInputChange={(event, newInputValue) => handleSubRowProductInputChange(mainRowIndex,subRowIndex, newInputValue)} // Add this line
                            isOptionEqualToValue={(option, value) => option.value === value.value} // Customize the equality test

                            renderInput={(params) => (
                              <TextField {...params} label="Product Name" />
                            )}
                          />
                          {subRow.productNameError && <div className="error-message" style={{ color: 'red' }}>{subRow.productNameError}</div>}
                         </div>
                         { row.subRows.length=== subRowIndex +1 &&
                          <div className='mt-2'>
                        <button onClick={() => handleAddSubRow(mainRowIndex )} style={{ marginTop: '2px' }} className='add_more_button'>
                          <AddIcon /> Add Product
                        </button>
                      </div>
                        }
                        </div>
                        {/* </Grid>
                        <Grid item xs={3}> */}
                        <div>
                          <TextField
                            id={`subquantity-${mainRowIndex}-${subRowIndex}`}
                            label="Quantity"
                            variant="outlined"
                            className="create_requisition_textfield"
                            value={subRow.quantity}
                            onChange={(event) => handleSubrowQuantityChange(mainRowIndex, subRowIndex, event.target.value)}
                            sx={{
                              width: {
                                xs: '100%',
                                sm: '190px',
                                md: '220px',
                                lg: {
                                  xs: '90%',
                                  lg: '220px',
                                },
                                xl: '260px',
                              },
                              '@media (min-width: 1200px) and (max-width: 1360px)': {
                                width: 'calc(250px - 50px)',
                               },
                            }}
                          />
                          {subRow.quantityError && <div className="error-message" style={{ color: 'red' }}>{subRow.quantityError}</div>}
                          </div>
                        {/* </Grid>
                        <Grid item xs={3}> */}
                        <div>
                          <TextField
                            id={`subvalue-${mainRowIndex}-${subRowIndex}`}
                            label="Value"
                            variant="outlined"
                            className="create_requisition_textfield"
                            value={subRow.value}
                            onChange={(event) => handleSubrowValueChange(mainRowIndex, subRowIndex, event.target.value)}
                            sx={{
                              width: {
                                xs: '100%',
                                sm: '190px',
                                md: '220px',
                                lg: {
                                  xs: '90%',
                                  lg: '220px',
                                },
                                xl: '260px',
                              },
                              '@media (min-width: 1200px) and (max-width: 1360px)': {
                                width: 'calc(250px - 50px)',
                               },
                            }}
                            disabled={true}
                          />
                          {subRow.valueError && <div className="error-message" style={{ color: 'red' }}>{subRow.valueError}</div>}
                          </div>
                        {/* </Grid>
                      </Grid> */}
                      <div>
                        <HighlightOffIcon
                            color='error'
                            onClick={() => handleSubRowDelete(mainRowIndex, subRowIndex)}
                            style={{ cursor: 'pointer', alignSelf: 'flex-start', marginTop: '10px' }}
                          />
                       </div>
                       </div>
                    </div>
                  ))}
                    {/* <div>
                      <button onClick={() => handleAddSubRow(mainRowIndex )}style={{  marginTop: row.subRows.length > 0 ? '19px' : '2px', marginLeft: row.subRows.length > 0 ? '0px' : '10px' }} className='add_more_button'>
                        <AddIcon /> Add Product
                      </button>
                    </div> */}
                  </div>
                </div>
              ))}
              <div style={{ width: 'calc(10% - 5px)', marginTop: '8px' }}>
                  <button className='add_more_button' onClick={handleAddRow}>+ Add More</button>
              </div>

            </CardBody>
          </Card>
          <div className='mb-2' style={{ display: 'flex', justifyContent: 'end'}}>
                  <button className="save_button" variant="contained" onClick={() => goToRequisition()} >Save</button>
          </div>
        </Container>
      </div>

        <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeModal}
          contentLabel="Example Modal"
        >
          <div>
              <div className='d-flex justify-content-end me-3 modal_close p-2'>
                <i class="ri-close-line" onClick={closeModal}></i>
              </div>
          </div>
          <ModalBody className='pt-2'>
            <div>
              <div className='hand_img'>
                  <img src={handImg} />
              </div>
              <div className="mt-3">
                <h4 className='text-center'>Would you like to delete all product items under this name?</h4>
              </div>
            </div>
            <div className='d-flex align-items-center mt-4 justify-content-center'>
              <button className="yes_button d-flex align-items-center" onClick={() => handleMainRowDelete(selectedRowIndex)}>
                              Yes
              </button>
              <button className="no_button d-flex align-items-center ms-3" onClick={closeModal}>
                              No
              </button>
            </div>
          </ModalBody>
        </Modal>
    </React.Fragment>
  );
}

export default NewSalesHeadCreateRequisition;
